import * as React from "react"
import { usePdp } from '~/contexts/PdpContext'

import Callouts from '~/components/shared/callouts'
import ReviewStars from '~/components/pdp/review-stars'

import * as styles from "~/styles/pdp/title.module.scss"

const Title = ({ mobiTop=false }) => {
  const { product } = usePdp()
  const { 
    title, pl_name, is_gift, is_single, variants, callouts, pl_colors, 
    percent_off, first_product_price, first_full_price, short_description
  } = product

  let has_reviews = product?.product_line?.has_reviews

  const cleanPrice = (str) => {
    return parseInt(str.replace('$','').replace(',',''))
  } 

  let vprices = false
  let vpricMin = false
  let vpricMax = false

  if ( is_gift ) {
    vprices = variants.map( (x) => x.title).sort((a, b) => cleanPrice(a) - cleanPrice(b))
    vpricMin = vprices[0].split('.')[0]
    vpricMax = vprices[vprices.length-1].split('.')[0]
  }

  return (
    <>
      {(has_reviews) && (
        <ReviewStars istop={true} desk={true} />
      )}

      {(callouts && callouts.length > 0) && (
        <Callouts callout_arr={callouts} wr_className={''} pdp={true} />
      )}

      <div className={styles.title_price}>
        <div className={styles.title}>
          {(is_single && !pl_colors.length > 1) ? title : pl_name}
        </div>

        <div className={styles.price}>
          {is_gift ? (
            <span 
              className={''}
              data-price-range={`${vpricMin}–${vpricMax}`} 
              data-price-min={vpricMin} 
              data-price-max={vpricMax}
            >
              {vpricMin}–{vpricMax}
            </span>
          ) : percent_off ? (
            <>
              <span className={styles.price_sale}>
                ({percent_off}% OFF)
              </span>
              <span className={styles.price_perc}>
                ${first_product_price}
              </span>
              <span className={styles.price_full}>
                ${first_full_price}
              </span>
            </>
          ) : (
            <>${first_product_price}</>
          )}
        </div>
      </div>

      {short_description && (
        <div className={styles.shortd}>
          {short_description}
        </div>
      )}

      {(has_reviews) && (
        <ReviewStars istop={true} />
      )}
    </>
  )
}

export default Title


